import React, { useEffect, useState } from "react";
import WorkHeader from "./Header";
import WorkSample from "./Sample";
import { scrollToTop } from "../../utils/helper";
import Animation from "./Animation";
import WorkHeading from "./WorkHeading";
import AnimationFilters from "./AnimationFilters";
import AOS from "aos";

function Work() {
  const [selected, setSelected] = useState("All");
  const [selectedFilter, setSelectedFilter] = useState("all");

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    AOS.refresh();
  }, [selected, selectedFilter]);

  return (
    <>
      <main className="container mx-auto h-full overflow-hidden">
        <WorkHeading />
        <AnimationFilters
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
        />
        <Animation selectedFilter={selectedFilter} />
        <WorkHeader selected={selected} setSelected={setSelected} />
        <WorkSample selected={selected} />
      </main>
    </>
  );
}

export default Work;
